import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Article } from '../../../model/Article';
import HttpClient from '../api';

const TRANSIENT_FIELD_ID = 99999999;

const INITIAL_STATE: Array<Article> = [];

const articlesSlice = createSlice({
  name: 'articles-template',
  initialState: INITIAL_STATE,
  reducers: {
    addArticle: (state, action: PayloadAction<Article>) => {
      const fields = action.payload.fields.map((it, index) => {
        if (it.id) {
          return it;
        } else {
          return { ...it, id: TRANSIENT_FIELD_ID + index };
        }
      });
      return [...state, { ...action.payload, fields }];
    },
  },
});

export const { addArticle } = articlesSlice.actions;

export default articlesSlice.reducer;

export const findArticleTemplateByCategory = (category: string) => {
  const customErrorsMap = new Map<number, string>();
  customErrorsMap.set(
    404,
    'A configuração do site precisa ser executada antes de abrir essa página',
  );
  return HttpClient.findArticlesTemplateByCategory(category, addArticle.type, customErrorsMap, []);
};
